<app-header></app-header>

<!-- <div class="container-fluid" style="float:left;" > -->
    <ngx-spinner></ngx-spinner>  
    <div class="row pb-2 mt-4 ml-1 mr-1">
        <div class="col">
            <h4>
                <div>{{ CreateShowHide ? 'Add Subcategory' : UpdateShowHide ? 'Edit Subcategory': 'Subcategories'}}</div>
            </h4>
        </div>
    </div>
    
    <div class="row mb-2 ml-1 mr-1">
        <div class="col">
          <button type="button" *ngIf="AddShowHide" (click)="AddSubCategory()" class="btn btn-success float-right">
            <i class="fas fa-plus-circle"></i> <span>Add Subcategory</span>
          </button>
        </div>
      </div>

    <form [formGroup]="frmSubCategory" *ngIf="CreateShowHide || UpdateShowHide">
        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-row">

                    <div class="form-group col-lg-2">
                        <label for="txtProductCategory" class="control-label required" >Product Category</label><span style="color:red;"> *</span>
                        <select class="form-control" formControlName="ProductCategoryId" id="txtProductCategory">
                          <option selected disabled value="">Choose...</option>
                          <option [ngValue]="category.id" *ngFor="let category of categories">{{category.productCategory1}}
                          </option>
                        </select>
                        <div *ngIf="frmSubCategory.get('ProductCategoryId').invalid && frmSubCategory.get('ProductCategoryId').touched"  class="validation">
                          <small *ngIf="frmSubCategory.get('ProductCategoryId').errors.required">
                            Must be required!!!
                          </small>
                          <small *ngIf="frmSubCategory.get('ProductCategoryId').errors.minlength">
                            Length must be greater then {{frmSubCategory.get('ProductCategoryId').errors.minlength.requiredLength}}.
                              Now length is {{frmSubCategory.get('ProductCategoryId').errors.minlength.actualLength}}
                          </small>
                        </div>
                      </div>

                    <div class="form-group col-lg-3">
                        <label for="txtProductSubCategory">Subcategory</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtProductSubCategory" formControlName="ProductSubCategory">
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="txtProductSubCategoryTitle">Title</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtProductSubCategoryTitle" formControlName="ProductSubCategoryTitle">
                    </div>
                </div>
            </div>
        </div>
        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-lg-7">
                        <label for=txtProductSubCategoryDescription>Description</label><span style="color:red;">&nbsp;*</span>
                        <textarea class="form-control" id="txtProductSubCategoryDescription" formControlName="ProductSubCategoryDescription" required aria-label="With textarea"></textarea>
                    </div>

                    <div class="form-group col-lg-1">
                      <label for="txtOrderBy">Order By</label><span style="color:red;">&nbsp;*</span>
                      <input type="text" class="form-control" id="txtOrderBy" formControlName="OrderBy">
                  </div>
                </div>
            </div>

        </div>

        <div class="row ml-1 mr-1">
            <div class="col">
              <div class="form-row">
                <div class="form-group col-lg-8">
                  <button type="button" class="btn btn-success" (click)="fileInput.click()" >Choose File</button><span style="color:red;"> *</span>
                  <input  hidden #fileInput type="file" accept=".jpg" id="file" formControlName="SubCategoryImage" (change)="setFilename(fileInput.files)" />
                  <label >{{ this.filename }}</label>          
                  <img *ngIf="isShown" src="{{this.baseUrl + this.productsubcategoryimagename}}" style="max-width:20%; height: auto;" alt="{{this.productsubcategoryimagename}}" title="{{this.productsubcategoryimagename}}">
                </div>
                 <div *ngIf="frmSubCategory.get('SubCategoryImage').invalid && frmSubCategory.get('SubCategoryImage').touched"  class="validation">
                  <small *ngIf="frmSubCategory.get('SubCategoryImage').errors.required">
                    Must be required!!!
                  </small>          
                </div> 
              </div>
            </div>
          </div>

        <div class="row ml-1 mr-1">
            <div class="col">
                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateSubCategory(fileInput.files)">
                    <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
                </button>
                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateSubCategory(fileInput.files)">
                    <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
                </button>
                <a>
                    <button type="button" aria-controls="addSubCategory"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
                        <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
                    </button>
                </a>    
            </div>
        </div>
    </form>
    
    
    
<!-- 
    <div class="row pb-2">
        <div class="col">
            <h4>Subcategories</h4>
        </div>
    </div>
    <div class="row mb-2">
    </div>
    <div class="modal fade" id="addSubCategory"tabindex="-1" #addSubCategory aria-labelledby="addSubCategory"aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="AddSubCategoryTitle">Enter Subcategory Information</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmSubCategory">
                        <div class="form-row">
                            <div class="col-md-4 mb-2">
                                <label for="txtProductSubCategory">Subcategory</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtProductSubCategory"
                                formControlName="ProductSubCategory"  readonly="readonly">
                            </div>
                            <div class="col-md-4 mb-2">
                                <label for="txtProductSubCategoryTitle">Title</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtProductSubCategoryTitle"
                                formControlName="ProductSubCategoryTitle"  readonly="readonly">
                            </div>
                            <div class="col-md-12 mb-2">
                              <label for=txtProductSubCategoryDescription>Description</label><span style="color:red;">&nbsp;*</span>
                              <textarea class="form-control" id="txtProductSubCategoryDescription" formControlName="ProductSubCategoryDescription" required
                                aria-label="With textarea"></textarea>
                            </div>    
                          </div>
                        <div class="modal-footer">
                          <div class="row">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateSubCategoru()">Add</button>
                                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide"data-toggle="modal" data-dismiss="modal" (click)="UpdateSubCategory()">Update</button>
                            </div>
                            <div class="col-md-6">
                                <button type="button" data-target="#addSubCategory" data-toggle="modal" aria-controls="addSubCategory"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div> -->
    <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            
                            <th scope="col">Product Category <span (click)="SortOder('ProductCategoryId')"><i class="fas fa-sort"></i></span></th>
                            <th scope="col">Product Subcategory <span (click)="SortOder('ProductSubCategory1')"><i class="fas fa-sort"></i></span></th>
                            <th scope="col">Description</th>
                            <th scope="col">Title</th>
                            <th scope="col">Order By</th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config ">
                            <td *ngIf="EditShowHide">
                              <table>
                                <tr>
                                  <td>
                                    <button type="button" class="btn btn-info btn-sm"
                                            (click)="EditSubCategory(item)" title="Edit">
                                      <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                    </button>
                                    <p style="visibility: hidden;margin-top: -34px;">{{item.Id}}</p>
                                  </td>
                                  <td>
                                    <button class="btn btn-info btn-sm" (click)="DeleteSubCategory(item.Id)" title="Delete">
                                      <i class="far fa-trash-alt fa-lg text-danger"></i>
                                      <span class="d-none d-md-inline d-lg-inline">Delete</span>
                                    </button>
                                  </td>
                                </tr>
                              </table>
                            </td>
                           
                            <td >{{GetCategory(item.ProductCategoryId)}}</td>
                            <td>{{item.ProductSubCategory1}}</td>
                            <td>{{item.ProductSubCategoryDescription}}</td>
                            <td>{{item.ProductSubCategoryTitle}}</td>
                            <td>{{item.OrderBy}}</td>

                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;">
                                <pagination-controls (pageChange)="pageChanged($event)" id="SubCategory"></pagination-controls>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
<!-- </div> -->
